import { render, staticRenderFns } from "./ModalChangePhone.vue?vue&type=template&id=b473421e&scoped=true&"
import script from "./ModalChangePhone.vue?vue&type=script&lang=js&"
export * from "./ModalChangePhone.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangePhone.vue?vue&type=style&index=0&id=b473421e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b473421e",
  null
  
)

export default component.exports